import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Modal, Button, Form } from 'react-bootstrap';

const AdminDecMatrix = () => {
  const [platformID, setPlatformID] = useState(null);
  const [authors, setAuthors] = useState([]);
  const [authorID, setAuthorID] = useState(null);
  const [matrixData, setMatrixData] = useState([]);
  const [selectedComment, setSelectedComment] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const API = process.env.REACT_APP_API_BASE_URL;
  const platformId = localStorage.getItem('platformID')

  useEffect(() => {
    const pid = parseInt(localStorage.getItem('platformID'));
    setPlatformID(pid);
  }, []);

  useEffect(() => {
    axios.get(`${API}/api/author/list`)
      .then(res => setAuthors(res.data))
      .catch(err => console.error("Author list error:", err));
  }, []);

  useEffect(() => {
    if (authorID) {
        //only i changed this api we get all the submission 
      axios.get(`${API}/api/admin/matrix`, {
        params: { authorID }

        //sujay 24/5/2025 we need to pass the submissionID
      }).then(res => setMatrixData(res.data))
        .catch(err => console.error("Matrix API Error:", err));
    }
  }, [authorID]);

  const handleCommentClick = async (submissionID, reviewerID, index) => {
    const res = await axios.get(`${API}/api/reviewer-decision/comment-detail`, {
      params: { submissionID, reviewerID, commentIndex: index }
    });
    setSelectedComment(res.data);
    setShowModal(true);
  };

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label>Select Author</Form.Label>
        <Form.Select
          value={authorID || ''}
          onChange={(e) => {
            const val = parseInt(e.target.value);
            setAuthorID(isNaN(val) ? null : val);
          }}
        >
          <option value="">-- Select Author --</option>
          {authors.map(author => (
            <option key={author.AuthorID} value={author.AuthorID}>{author.AuthorName}</option>
          ))}
        </Form.Select>
      </Form.Group>

      <div className="table-responsive mt-3">
        {matrixData.length ?
          <table className="table table-bordered text-center">
            <thead className="bg-primary text-light">
              <tr>
                <th>Submission</th>
                <th>Reviewer</th>
                <th colSpan={5}>Comments & Author Replies</th>
              </tr>
            </thead>
            <tbody>
              {matrixData.map((row, index) => (
                <tr key={index}>
                  <td>{row.SubmissionTitle}</td>
                  <td>{row.ReviewerName ? `${row.ReviewerName.charAt(0)}*****${row.ReviewerName.slice(-1)}` : 'Reviewer'}</td>
                  {[1, 2, 3, 4, 5].map(n => (
                    <td
                      key={n}
                      style={{ cursor: n <= row.TotalComments ? 'pointer' : 'default' }}
                      onClick={() => n <= row.TotalComments && handleCommentClick(row.submissionID, row.ReviewerID, n)}
                    >
                      {n <= row.TotalComments ? n : ''}
                    </td>
                  ))}
                </tr>
              ))
              }
            </tbody>
          </table>
          : <div class="alert alert-dark fw-bold text-center mb-3 rounded shadow-sm mt-3" role="alert">
            No comments on any submissions for this author
          </div>
        }
      </div>

      {/* Modal Fix with Full Structure */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="xl">
        <Modal.Header closeButton>
          <Modal.Title>Comments & Author Replies</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedComment ? (
            <div className="row">
              {/* Reviewer Comment */}
              <div className="col-md-6 mb-3">
                <div className="p-3 bg-light border-start border-4 border-warning shadow-sm rounded-start">
                  <h6 className="text-warning fw-bold">Comment</h6>
                  <p>{selectedComment.Comment || 'N/A'}</p>
                  <p><strong>Date:</strong> {selectedComment.ReviewDate ? new Date(selectedComment.ReviewDate).toLocaleString() : 'N/A'}</p>
                  <p><strong>Decision:</strong> {selectedComment.Decision === "AcceptWithComment" ? "Comment" : selectedComment.Decision || 'N/A'}</p>
                </div>
              </div>

              {/* Author Reply */}
              <div className="col-md-6 mb-3">
                <div className="p-3 bg-light border-start border-4 border-success shadow-sm rounded-start">
                  <h6 className="text-success fw-bold">Reply</h6>
                  <p>{selectedComment.AuthorReply || 'No reply yet'}</p>
                  <p><strong>Date:</strong> {selectedComment.AuthorReplayDate ? new Date(selectedComment.AuthorReplayDate).toLocaleString() : 'N/A'}</p>

                </div>
              </div>
            </div>
          ) : (
            <p>Loading...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>Close</Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default AdminDecMatrix;
